import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIState, SnackbarState } from '../../types/store';

const initialState: UIState = {
  snackbar: {
    message: '',
    severity: 'success',
    duration: 3000,
    alertClose: false
  },

  pageLoading: {}
};

/**
 * UI state slice for managing UI components and notifications
 * Handles snackbar notifications and per-page loading states
 */
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    /**
     * Sets loading state for a specific page
     * @param {UIState} state - Current state
     * @param {PayloadAction<{page: string, loading: boolean}>} action - Page name and loading state
     */
    setPageLoading: (state, action: PayloadAction<{ page: string; loading: boolean }>) => {
      state.pageLoading[action.payload.page] = action.payload.loading;
    },
    setSnackbarData: (state, action: PayloadAction<SnackbarState>) => {
      state.snackbar = { ...action.payload };
    },
    clearSnackbarData: state => {
      state.snackbar = {
        message: '',
        severity: undefined,
        duration: undefined,
        alertClose: undefined
      };
    }
  }
});

export const { setPageLoading, setSnackbarData, clearSnackbarData } = uiSlice.actions;
export default uiSlice.reducer;
